import './styles.scss'
import * as React from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { ALLOWED_DOMAINS } from 'constants/index'

const EditFloat = (props) => {
  return (
    <div className='button-container'>
      <UncontrolledDropdown direction='down' className={``}>
        <DropdownToggle className={'show-comments-btn'}>
          <i className='fa fa-ellipsis-h'/>
        </DropdownToggle>
        <DropdownMenu className='menu-options'>
          {props.isBusinessSchedule &&(
            <>
              <DropdownItem onClick={() => props.businessScheduleAction('office')}>{I18n.t('dashboard_business-schedule')}</DropdownItem>
              {ALLOWED_DOMAINS.type === 'TA' && <DropdownItem onClick={() => props.businessScheduleAction('refundAutomatic')}>{I18n.t('message_refund_schedule_modal_title')}</DropdownItem>}
            </>
          )}
          {props.isEdit && <DropdownItem onClick={props.editAction}>{I18n.t('dashboard_edit')}</DropdownItem>}
          {props.isRemove && <DropdownItem onClick={props.removeAction}>{I18n.t('dashboard_delete')}</DropdownItem>}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  )
}

export default EditFloat
